var map = {
	"./en.json": [
		"./src/assets/i18n/en.json",
		1
	],
	"./es-eu.json": [
		"./src/assets/i18n/es-eu.json",
		2
	],
	"./es.json": [
		"./src/assets/i18n/es.json",
		3
	],
	"./fr.json": [
		"./src/assets/i18n/fr.json",
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/assets/i18n lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;